<ng-container *ngIf="urlNavigated != '/session-expired'">
  <div id="loading-session-security" *ngIf="shouldShowLoading">
    <mat-spinner class="mat-spinner-grey-200" [diameter]="40"></mat-spinner>
  </div>
</ng-container>
<router-outlet></router-outlet>
